import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { Animated, Easing, Platform, View } from 'react-native';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { getColorScheme } from '../../Hooks/UseColorScheme';
import { Shadow } from '../../Styles/Shadow';
export const InlineModalView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.inlineModal,
    style() {
        return {
            wrapper: {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            },
            container: Object.assign(Object.assign({ borderRadius: 8 }, Shadow.level(1)), { backgroundColor: getColorScheme().value.colors.background }),
            noShadow: {
                shadowColor: undefined,
                shadowOffset: undefined,
                shadowOpacity: undefined,
                shadowRadius: undefined,
                elevation: undefined
            }
        };
    }
})((props) => {
    var _a, _b, _c;
    const [isVisible, setIsVisible] = useState(false);
    const lastVisible = useRef(false);
    const animation = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        if (props.visible === lastVisible.current) {
            return;
        }
        lastVisible.current = props.visible;
        if (props.visible) {
            setIsVisible(props.visible);
            Animated.timing(animation, {
                toValue: 1,
                duration: props.animationDuration || 150,
                useNativeDriver: Platform.OS !== 'web',
                easing: Easing.linear
            }).start();
            return;
        }
        Animated.timing(animation, {
            toValue: 0,
            delay: props.delayHide || 0,
            duration: props.animationDuration || 150,
            useNativeDriver: Platform.OS !== 'web',
            easing: Easing.linear
        }).start(() => setIsVisible(false));
    }, [props.visible]);
    const wrapperStyle = useMemo(() => {
        var _a;
        return [
            (_a = props.style) === null || _a === void 0 ? void 0 : _a.wrapper,
            props.wrapperStyle,
            { opacity: animation }
        ];
    }, [(_a = props.style) === null || _a === void 0 ? void 0 : _a.wrapper, props.wrapperStyle]);
    const containerStyle = useMemo(() => {
        var _a, _b;
        return Object.assign(Object.assign(Object.assign({}, (_a = props.style) === null || _a === void 0 ? void 0 : _a.container), props.containerStyle), props.noShadow && ((_b = props.style) === null || _b === void 0 ? void 0 : _b.noShadow));
    }, [(_b = props.style) === null || _b === void 0 ? void 0 : _b.container, props.containerStyle, props.noShadow, (_c = props.style) === null || _c === void 0 ? void 0 : _c.noShadow]);
    if (!isVisible) {
        return null;
    }
    return (_jsx(Animated.View, { style: wrapperStyle, needsOffscreenAlphaCompositing: true, children: _jsx(View, { style: containerStyle, children: props.children }) }));
});
